import { CheckboxCell } from "@silevis/reactgrid";
import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";
import { SelectCellTemplate } from "pages/BankStatements/BankStatementsGrid/customcells/SelectCellTemplate";

// Several invoices can be ticked at once (re-match / delete act on all ticked rows, as
// invalidation does on the Payments page); the detail pane shows the entries of the
// invoice ticked last.
class SelectCellTypeHandler implements ICellTypeHandler {
  cellType = "select";
  isCustom = true;
  instance = new SelectCellTemplate();
  determineNewValue = (change: any) => {
    return (change.newCell as CheckboxCell).checked;
  };
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    }
  ) => {
    const [, { toggleImportedInvoiceSelection }] =
      context["importedInvoicesStore"];
    const rowId = entry[columnConfig.additionalInfo.rowIdField];

    return {
      type: "select",
      selected: rowsMetadataMap[entry[keyColumn]]?.selected ?? false,
      highlighted: rowsMetadataMap[entry[keyColumn]]?.highlighted ?? false,
      checked: rowsMetadataMap[rowId]?.selected ?? false,
      onChecked: (checked: boolean) => {
        toggleImportedInvoiceSelection(rowId, checked);
      },
    };
  };
}

export default SelectCellTypeHandler;
